module.exports = __webpack_public_path__ + "static/media/GD.1d1439d0.png";